import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import getButtonText from '~/utils/text/getButtonText';
import { EDIT_TEAM_MEMBER } from '~/ui/constants/paths';
import { IActTeamMember, Status as UserStatus } from '~/services/api/actTeamMember/types';

import editDisabledIcon from '~/ui/assets/images/editDisabled.svg';
import editIcon from '~/ui/assets/images/editGrey.svg';

import styles from './TeamMembers.module.scss';

interface IProps {
  actTeamMember: IActTeamMember;
  actTeamId: string;
  noActions?: boolean;
  setTeamMember: (v: IActTeamMember) => void;
  isTeamLeader: boolean;
  isTeamMember: boolean;
  isOnlyGlobalUser: boolean;
  isCurrentUser: boolean;
  actionsNotAllowed: boolean;
}

const TeamMemberActions = ({
  actTeamMember,
  actTeamId,
  noActions,
  setTeamMember,
  isTeamLeader,
  isTeamMember,
  isOnlyGlobalUser,
  isCurrentUser,
  actionsNotAllowed,
}: IProps): ReactElement | null => {
  const navigate = useNavigate();

  if (noActions) return null;

  return (
    <>
      {/* Edit action */}
      <TableCell>
        {['Deactivated', 'Locked'].includes(actTeamMember.status) ? (
          <IconButton disabled>
            <img src={editDisabledIcon} alt="disabled" />
          </IconButton>
        ) : (
          <IconButton
            onClick={() =>
              navigate(
                EDIT_TEAM_MEMBER.replace(':actTeamId', actTeamId).replace(
                  ':teamMemberId',
                  String(actTeamMember.id),
                ),
              )
            }
          >
            <img src={editIcon} alt="edit" />
          </IconButton>
        )}
      </TableCell>

      {/* Archive / Deactivate / Activate / Resend Invitation / Unlock actions / Restore */}
      <TableCell className={styles.column}>
        <button
          type="button"
          className={styles.actionButton}
          onClick={() => setTeamMember(actTeamMember)}
          disabled={(actTeamMember.status === 'Active' && isCurrentUser) || actionsNotAllowed}
        >
          {getButtonText(actTeamMember.status)}
        </button>
        {actTeamMember.status === 'Pending' && (
          <button
            type="button"
            className={styles.actionButton}
            onClick={() =>
              setTeamMember({
                ...actTeamMember,
                status: 'VerifyingEmail' as UserStatus,
              })
            }
            disabled={actionsNotAllowed}
          >
            Archive
          </button>
        )}
      </TableCell>

      {/* Unassign action */}
      <TableCell>
        <button
          type="button"
          disabled={
            actTeamMember.status !== 'Active' || (isTeamLeader && !isTeamMember) || isOnlyGlobalUser
          }
          className={styles.actionButton}
          onClick={() => setTeamMember({ ...actTeamMember, status: 'Assigned' as UserStatus })}
        >
          Unassign
        </button>
      </TableCell>
    </>
  );
};

export default TeamMemberActions;
